<template>
    <div>
        <div class="mb-4 mt-2 px-10">
            <img class="mx-auto w-full rounded-2xl" :src="campaign.FullImageUrl" />
        </div>
        <div class="text-14 font-bold text-a-brown-502314 text-center mb-6" v-html="getname(campaign.detail)">
        </div>
        <div class="px-10">
            <RedButton @click="clickOrderNow()">
                Order Now!
            </RedButton>
        </div>
    </div>
</template>
<script>
import RedButton from '@/components/Button/RedButton.vue'
import Utility from '@/helper/Utility'
import { CampaignType } from "@/helper/StaticValue.js";

export default {
    name: 'NotificationTypeCampaign',
    props: {
        campaign: {
            type: Object
        }
    },
    components: { RedButton },
    mixins: [],
    emits: [],
    data: function () { return {} },
    computed: {},
    created: function () { },
    mounted: function () { },
    methods: {
        clickOrderNow: function () {
            if (this.campaign.Type == CampaignType.Buy) {
                this.$router.push({
                    name: "product_detail",
                    params: {
                        id: this.campaign.ID ?? this.campaign.Id
                    }
                });
            } else {
                this.$router.push({
                    name: "reward_detail",
                    params: {
                        campaignId: this.campaign.ID ?? this.campaign.Id
                    }
                });
            }
        },
        getname: function (name) {
            return Utility.newLineToBr(name);
        }
    }
}
</script>
